import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  HostListener,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { AccountRepositoryService } from 'app/account-repository.service';
import { ExpressyonService } from 'app/expressyon.service';
import { TranslateModule } from '@ngx-translate/core';
import { AnswersRepositoryService } from '../answers-repository.service';
import { AppComponent } from 'app/app.component';
import { SurveyRepositoryService } from 'app/survey-repository.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isWeb: boolean = false;
  isConnected: boolean;
  answersCount: number;
  isInAdminMode: Boolean = false;
  hasSurvey: Boolean = false;
  displayChangeSurvey: Boolean = false;
  group: any;
  showReturn: Boolean = false;
  showMenu: Boolean = true;
  isLoginPage: boolean = false;
  // Émis au clic sur l'icône de rafraîchissement (affichée sur la page login)
  @Output() refresh = new EventEmitter<void>();
  // Compteur d'appuis sur le bouton invisible (page login) : 5 appuis
  // rapprochés ouvrent la page cachée de création de device standalone.
  hiddenTapCount = 0;
  hiddenTapTimer: any = null;
  dropdownDisplay: boolean = false;
  IsUpdateAvailable: boolean;
  licenceType: string;

  constructor(
    private accountRepository: AccountRepositoryService,
    private router: Router,
    private expressyonService: ExpressyonService,
    private answersRepository: AnswersRepositoryService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.isConnected = this.expressyonService.getNetworkStatus();

    this.answersRepository.answersCountChange.subscribe((value) => {
      this.answersCount = value;
      this.changeDetector.detectChanges();
    });

    this.expressyonService.networkStatusChange.subscribe((value) => {
      this.isConnected = value;
      this.changeDetector.detectChanges();
    });
  }

  getSurveyCanSelectInHand() {
    return AppComponent.surveyCanSelectInHand;
  }

  ngOnInit(): void {
    this.answersCount = this.answersRepository.getAnwserCount();
    this.isInAdminMode = this.accountRepository.getIsInAdminMode();
    this.hasSurvey = this.expressyonService.hasSurvey();
    this.displayChangeSurvey = this.expressyonService.IsUpdateLaunched;
    this.group = this.accountRepository.getGroup();
    this.showReturn =
      this.accountRepository.isLogged() &&
      this.expressyonService.hasValidSurvey() &&
      this.router.url !== '/startSurvey';
    // L'URL peut porter des query params (queryParamsHandling: 'merge'),
    // ex. "/?timestamp=..." : on compare donc le chemin sans les params.
    const path = this.router.url.split('?')[0];
    this.isLoginPage = path == '/';
    this.showMenu = path != '/' && !path.startsWith('/deviceCreate');
    this.IsUpdateAvailable = this.expressyonService.getIsUpdateAppAvailable();
    this.isWeb = this.expressyonService.getIsWeb();
    this.licenceType = this.accountRepository.getLicenceType();
  }

  /**
   * Bouton invisible en haut à gauche du header sur la page login :
   * 5 appuis en moins de 3 secondes ouvrent la page cachée de création
   * de device standalone (sans licence).
   */
  hiddenTap() {
    this.hiddenTapCount++;
    clearTimeout(this.hiddenTapTimer);
    if (this.hiddenTapCount >= 5) {
      this.hiddenTapCount = 0;
      this.router.navigate(['deviceCreate'], {
        replaceUrl: true,
        queryParamsHandling: 'merge',
      });
      return;
    }
    this.hiddenTapTimer = setTimeout(() => (this.hiddenTapCount = 0), 3000);
  }

  logout() {
    this.dropdownDisplay = false;
    this.router.navigate(['logout'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  update() {
    if (!this.isConnected) {
      // Show an error to the client please
      return;
    }
    this.accountRepository.setGroup(null);
    this.dropdownDisplay = false;
    this.router.navigate(['update'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  openAbout() {
    this.dropdownDisplay = false;
    this.router.navigate(['about'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  openDevice() {
    this.dropdownDisplay = false;
    this.router.navigate(['device'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  selectSurvey() {
    this.dropdownDisplay = false;
    this.expressyonService.setUpdateLaunched = false;
    this.router.navigate(['/selectSurvey'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  redirect() {
    this.dropdownDisplay = false;
    this.router.navigate(['startSurvey'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  quitApp() {
    this.dropdownDisplay = false;
    this.router.navigate(['quit-app'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }
  sendAnswers() {
    this.dropdownDisplay = false;
    this.router.navigate(['send-answers'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  updateApp = function () {
    this.dropdownDisplay = false;
    this.router.navigate(['/update-app'], {
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  };

  //Désactiver le menu si click à l'extérieur de celui ci
  wasInside;
  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }

  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.dropdownDisplay = false;
      this.changeDetector.detectChanges();
    }
    this.wasInside = false;
  }
}
